module.exports = __webpack_public_path__ + "img/5.ab18fe0e.jpg";